import { forwardRef, memo, type Ref } from 'react';
import { FormDropdown } from '~/commonComponents/FormDropdown';
import { DropdownOption } from '~/commonComponents/FormDropdown/DropdownOption';

interface IMealBreakPaidFieldProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
  isOpen: boolean;
  onToggle: () => void;
}

const OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
] as const;

const Component = (
  { value, onChange, isOpen, onToggle }: IMealBreakPaidFieldProps,
  ref: Ref<HTMLDivElement>,
) => {
  const displayValue = value ? 'Yes' : 'No';

  return (
    <div ref={ref}>
      <FormDropdown
        label="Meal Break Paid"
        value={displayValue}
        isOpen={isOpen}
        onToggle={onToggle}
        testId="meal-break-paid-field"
      >
        {OPTIONS.map((option) => (
          <DropdownOption
            key={option.label}
            isSelected={value === option.value}
            onSelect={() => {
              onChange?.(option.value);
              onToggle();
            }}
            testId={`meal-break-paid-option-${option.label.toLowerCase()}`}
          >
            {option.label}
          </DropdownOption>
        ))}
      </FormDropdown>
    </div>
  );
};

export const MealBreakPaidField = memo(forwardRef(Component));
